<template>
    <!-- Footer -->
    <div class="footer" style="background-color:#262431;">
        <div class="container">
            <div class="row">
                <div class="col-md-4">
                    <div class="footer-col">
                        <h4>Arcane Spectacles</h4>
                        <img src="../assets/images/Arcane_Spectacles_TransparentBG.png" style="width:80px;margin-bottom:1em;">
                        <p>We are a family operated TTRPG accessory business. We have a passion for creating new spectacles to enrich your ttrpg experience, such as finding new uses for dice or helping simplify complex rules.</p>
                    </div>
                </div> <!-- end of col -->
                <div class="col-md-4">
                    <div class="footer-col middle">
                        <h4>Important Links</h4>
                        <ul class="list-unstyled li-space-lg">
                            <li class="media">
                                <div class="media-body"><a class="turquoise" href="arcanespectacles.etsy.com">Arcane Spectacles Shop</a></div>
                            </li>
                            <li class="media">
                                <div class="media-body"><a class="turquoise" href="dieharddice.com">Die Hard Dice Shop</a></div>
                            </li>
                            <li class="media">
                                <div class="media-body"><a class="turquoise" href="https://media.wizards.com/2016/downloads/SRD-OGL_V1.1.pdf">D&D System Reference Document</a></div>
                            </li>
                        </ul>
                    </div>
                </div> <!-- end of col -->
                <div class="col-md-4">
                    <div class="footer-col last">
                        <h4>Social Media</h4>
                        <span class="fa-stack">
                            <a href="https://twitter.com/ArcaneSpectacle">
                                <i class="fas fa-circle fa-stack-2x"></i>
                                <i class="fab fa-twitter fa-stack-1x"></i>
                            </a>
                        </span>
                    </div> 
                </div> <!-- end of col -->
            </div> <!-- end of row -->
        </div> <!-- end of container -->
    </div> <!-- end of footer -->  
    <!-- end of footer -->
</template>

<script>
export default {
  name: 'FooterSection'
}
</script>


// WEBPACK FOOTER //
// src/components/FooterSection.vue